import { WaitlistEnabled } from '../components/Activity/Common/Common';
import { FCResourceViewTypes } from '../enums/fcResourceVIewTypes';

export const CALENDAR_EVENT_COLOR = '#0073BB';
export const UNAVAILABLE_EVENT_COLOR = '#F2F3F3';
export const HOLIDAY_EVENT_COLOR = 'darkgray';
export const INITIAL_CALENDAR_VIEW_TYPE = FCResourceViewTypes.Week;

export const DEFAULT_ACTIVITY_STATUS = 'Hold';
export const DEFAULT_LANGUAGE = 'English';
export const DEFAULT_TIMEZONE = 'America/Los_Angeles';
export const DEFAULT_CURRENCY = 'USD';
export const DEFAULT_PROVIDER = 'AWS';
export const DEFAULT_WAITLIST_OPTION = WaitlistEnabled.Disabled;

export const TOF_STATUS_OPTIONS = [
    'Not Started',
    'With Customer',
    'Signature Received',
    'Expired',
];

export const DEFAULT_ACTIVITY_SOURCE_FIELDS = [
    'pk',
    'activity_name',
    'activity_status',
    'activity_audience',
    'activity_modality',
    'activity_group_name',
    'program',
    'room',
    'course_name',
    'course_catalog_item_id',
    'course_days',
    'activity_type',
    'provider',
    'operation_owners_email',
    'delivery_sessions',
    'delivery_country',
    'delivery_region',
    'delivery_geo',
    'delivery_language',
    'instructors',
    'delivery_timezone',
    'delivery_address_1',
    'delivery_address_2',
    'delivery_postal_code',
    'delivery_city',
    'delivery_state',
    'delivery_country',
    'lms_id',
    'lms_type',
    'customers',
    'class_size',
];

export enum V_ILT_TYPE {
    WEBEX = 'WebEx',
}

/**
 * The WebEx site that hosts auto-created vILT meetings. Co-host (host
 * permission) assignment requires each owner to hold a WebEx Meetings license
 * on this site.
 */
export const WEBEX_SITE = 'awsvirtual.webex.com';
